const Profile = (props) => {
  return (
    <>
      <div className="avatar_details ">
        {props?.data?.map((profile) => {
          return(
          <div
            key={profile.id}
            className={`flex items-center ${profile?.position == "horizontal" ? "gap-x-3" : "gap-x-6 flex-col"
              }`}
          >
            <img
              className={`h-16 w-16 ${profile?.imageClassName}`}
              src={profile?.avatarImg}
              alt="Avatar Image"
            />
            <div className={`${profile?.dataClassName}`}>
              <h3 className="mb-1">{profile?.profileName}</h3>
              <p className="">{profile?.designation}</p>
              {profile?.showStream == "yes" ? (
                <span className="">
                  Stream : {profile?.stream} <br/> <span>{profile?.division}</span>
                </span>
              ) : (
                <></>
              )}
            </div>
          </div>
        )})}
      </div>
    </>
  );
};

export default Profile;

